import { configureStore } from '@reduxjs/toolkit';
// import authSlice from '../slices/authSlice';
// import getuserSlice from '../slices/profileSlice';
import { apiSlice } from './service/Service';
import PlayerToPlayerSaveCardReducer from '../features/UserFeatures/Cards/cardsSave/CardsSaveSlice'

export const store = configureStore({
  reducer :{
    playerCardDetail : PlayerToPlayerSaveCardReducer,
   
      // [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({serializableCheck: false,}).concat(apiSlice.middleware),
  devTools: true
})
 
